import React, {PureComponent} from 'react';
import KickImage from 'Reuseables/KickImage';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Container,
    } from 'reactstrap';

class Disbursement extends PureComponent {
  _renderHeader = () => {
    if(this.props.dataSell){
      return(<span>ORD ID : <span id="invoice-number">{this.props.dataSell[1].invoice_number}</span></span>)
    }
    return null
  }

  _textInfo = () => {
    return(`Proses disbursement harap hubungi Whatsapp: +6281210005425`)
  }

  _renderParagraph = () => {
    if(this.props.dataSell)
      return(
        <p>
            <span id="display_name">{this.props.dataSell[2].product_variant.display_name}</span><br/><br/><br/>
            {/* Jumlah yang harus dibayarkan:<br/><br/> */}
            <span id="price">{`IDR. ${this.props.dataSell[1].price},-`}</span><br/><br/><br/>
            {this._textInfo()}
        </p>
      )
  }

  _renderButton = () => {
    return null
  }

  render(){
      return(
        <Modal isOpen={this.props.isOpen} toggle={this.props.onToggle} className="kick-modal payment-pending">
          <Container id="payment">
            <ModalHeader id="header-payment-pending">
              {this._renderHeader()}
            </ModalHeader>
            <ModalBody>
              {this._renderParagraph()}
            </ModalBody>
            <ModalFooter>
              {this._renderButton()}
            </ModalFooter>
          </Container>
        </Modal>
      )
  }
}

Disbursement.propTypes={
}

Disbursement.defaultProps={
}

export default Disbursement